import React, {useContext} from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import Typography from "components/Typography";
import {Collapse} from "@material-ui/core";
import PurchaserDataTogether from "./PurchaserDataTogether";
import PurchaserDataEntrusted from "./PurchaserDataEntrusted";
import getObjectValue from "libs/getObjectValue";
import Tr from "translations/Translations";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";


function PurchaserData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    const {getDict} = useContext(FormTranslationContext)

    return (<>

        <Typography>{Tr("bzp_notice_purchaser_data_info")}</Typography>
        <br/>

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("phoneNumber")}
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("faxNumber")}
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("email")}
            required
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("ezamowieniaDemand")}
            required
            disabled={updateNotice}
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("www")}
            required
            disabled={updateNotice && gVal("ezamowieniaDemand")}
        />

        <NoticeGlossaryInput
            id={gId("type")}
            formikProps={formikProps}
            items={getDict("SL.MO.013")}
            required
        />

        <Collapse in={gVal("type") === "1.5"}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("typeOther")}
                required
            />
        </Collapse>

        <NoticeGlossaryInput
            id={gId("activitySubject")}
            formikProps={formikProps}
            items={getDict("SL.MO.014")}
            required
        />

        <Collapse in={gVal("activitySubject") === "11"}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("activitySubjectOther")}
                required
            />
        </Collapse>

        <NoticeGlossaryInput
            id={gId("role")}
            formikProps={formikProps}
            items={getDict("ENUM.001")}
            required
        />

        <Collapse in={gVal("role") === 'wspolnie'} unmountOnExit>
            <PurchaserDataTogether formikProps={formikProps} id={gId("together")} />
        </Collapse>

        <Collapse in={gVal("role") === 'powierzony'} unmountOnExit>
            <PurchaserDataEntrusted formikProps={formikProps} id={gId("entrusted")} />
        </Collapse>

    </>)
}

PurchaserData.propTypes = {};

export default PurchaserData;
